<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
          <el-form-item label="会员名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="会员名称"></el-input>
      </el-form-item>
          <el-form-item label="会员等级说明" prop="describer">
          <el-input v-model="dataForm.describer" placeholder="会员等级说明"></el-input>
      </el-form-item>
          <el-form-item label="购买金额" prop="vipMoney">
          <el-input v-model="dataForm.vipMoney" placeholder="购买金额"></el-input>
      </el-form-item>
          <el-form-item label="招募经纪人数" prop="recruitCount">
          <el-input v-model="dataForm.recruitCount" placeholder="招募经纪人数"></el-input>
      </el-form-item>
          <!-- <el-form-item label="提成" prop="royaltyRate">
          <el-input v-model="dataForm.royaltyRate" placeholder="提成"></el-input>
      </el-form-item> -->
          <el-form-item label="上级津贴" prop="parentRate">
          <!-- <el-input v-model="dataForm.parentRate" placeholder="上级津贴"></el-input> -->
          <el-input-number size="small" v-model="dataForm.parentRate" controls-position="right" :min="0" :max="1" :step="0.1" :precision="2"></el-input-number>
      </el-form-item>
          <el-form-item label="上上级津贴" prop="superRate">
            <el-input-number size="small" v-model="dataForm.superRate"  controls-position="right" :min="0" :max="1" :step="0.1" :precision="2"></el-input-number>
          <!-- <el-input v-model="dataForm.superRate" placeholder="上上级津贴"></el-input> -->
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="dataForm.status" placeholder="是否删除 0：否，1：是"></el-input> -->
          <el-select  v-model="dataForm.status" filterable clearable  placeholder="请选择状态">
                  <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
          <!-- <el-form-item label="redEnvelopeRuleId" prop="redEnvelopeRuleId">
          <el-input v-model="dataForm.redEnvelopeRuleId" placeholder=""></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      statusList:[
          {
            value: 0,
            label:'有效'
          },
          {
            value: 1,
            label:'无效'
          }
        ],
      dataForm: {
        id: '',
        name: '',
        describer: '',
        vipMoney: '',
        recruitCount: '',
        royaltyRate: '',
        parentRate: '',
        superRate: '',
        status: '',
        redEnvelopeRuleId: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        describer: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        vipMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        recruitCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        royaltyRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        parentRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        superRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        redEnvelopeRuleId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    inputs(e){
      console.log(e)
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/sluserviplevel/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      
   
      let obj = JSON.parse(JSON.stringify(this.dataForm)) 
      obj.parentRate =  obj.parentRate + ''
      obj.superRate += ''
       
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
      
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/sluserviplevel/', obj).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
